"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var Player = (function (_super) {
    __extends(Player, _super);
    function Player() {
        var _this = _super.call(this) || this;
        _this.onStopped(function () {
            setTimeout(function () {
                _this.currentPositionObservable.reset();
                _this.durationObservable.reset();
                _this.bitrateObservable.reset();
                _this.currentAudioTrackObservable.reset();
                _this.availableAudioTracksObservable.reset();
                _this.currentSubtitlesTrackObservable.reset();
                _this.availableSubtitlesTracksObservable.reset();
                _this.bufferInfoObservable.reset();
            });
        }, _this);
        _this.onStateChanged(function (state) {
            _this.currentState = state;
        }, _this);
        return _this;
    }
    Player.prototype.nativeSetAbrConfig = function (config) {
        this.notifyWarning('ABR_CONFIG_NOT_SUPPORTED', 'Changing the ABR config is not implemented on this device');
    };
    Player.prototype.nativeEnableSubtitles = function (subtitlesTrack) {
        this.notifyWarning('NATIVE_SUBTITLES_NOT_SUPPORTED', 'Subtitles are not implemented on this device');
    };
    Player.prototype.nativeDisableSubtitles = function () {
        this.notifyWarning('NATIVE_SUBTITLES_NOT_SUPPORTED', 'Subtitles are not implemented on this device');
    };
    Player.prototype.nativeSetAudioTrack = function (audioTrack) {
        this.notifyWarning('NATIVE_AUDIO_NOT_SUPPORTED', 'Audio switching is not implemented on this device');
    };
    Player.prototype.nativeSetMute = function (isMute) {
        this.notifyWarning('NATIVE_VOLUME_NOT_SUPPORTED', 'Changing the volume is not implemented on this device');
    };
    Player.prototype.nativeSetVolume = function (volume) {
        this.notifyWarning('NATIVE_VOLUME_NOT_SUPPORTED', 'Changing the volume is not implemented on this device');
    };
    Player.prototype.nativeSeek = function (position) {
        this.initiateSeek(position);
        return this.waitForState(__1.PlayerState.Playing);
    };
    Player.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: window.innerWidth,
            height: window.innerHeight,
        };
    };
    return Player;
}(__1.CommonPlayer));
exports.Player = Player;
